import React from 'react'
import {TextWrapper, Text, CarouselContainer, CarouselElement} from './reviewElements';
import "react-responsive-carousel/lib/styles/carousel.min.css";


const ReviewSection = ({review, author, review2, author2, review3, author3, id}) => {
    return (
        <CarouselContainer id = {id}>
            <CarouselElement showStatus = {false}>
                <TextWrapper>
                    <Text>{review}</Text>
                    <Text>{author}</Text>
                </TextWrapper>
                <TextWrapper>
                    <Text>{review2}</Text>
                    <Text>{author2}</Text>
                </TextWrapper>
                <TextWrapper>
                    <Text>{review3}</Text>
                    <Text>{author3}</Text>
                </TextWrapper>
            </CarouselElement>
        </CarouselContainer>
    )
}

export default ReviewSection
